import { useTranslation } from "react-i18next";

import { IconButton } from "../molecules/iconButton";
import { Icon } from "../atoms/icons";

import type { IFileViewerIconButtonProps } from ".";

import type { IFileViewerType } from "@/hooks/useFileViewer";
import { useFileViewer } from "@/hooks/useFileViewer";

export function FileViewerIconButtonContainer(props: {
  file: IFileViewerType;
}) {
  const { file } = props;

  const { canShow, show, fileData } = useFileViewer(file);

  return (
    <FileViewerIconButton
      canShow={canShow}
      onClick={show}
      url={fileData?.url || ""}
    />
  );
}

export function FileViewerIconButton(props: IFileViewerIconButtonProps) {
  const { canShow, onClick, url } = props;

  const { t } = useTranslation("common");

  return (
    <IconButton
      icon={
        canShow ? (
          <Icon name={"Eye"} color={"primary-main"} />
        ) : (
          <a href={url}>
            <Icon name={"Download"} color={"primary-main"} />
          </a>
        )
      }
      transparent
      label={canShow ? t("view") : t("download")}
      onClick={() => {
        if (canShow) onClick?.();
      }}
    />
  );
}
